module.exports = __webpack_public_path__ + "img/save.d9c834c9.svg";